import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { TranslateModule } from '@ngx-translate/core';

import { SeUiControlsModule, SeUiUtilitiesModule } from '@se/se.ui.html5';

import { SeToolbarComponent } from './se-toolbar/se-toolbar.component';

import { SeIteratorActionsComponent } from './se-iterator-actions/se-iterator-actions.component';

import { SeValidationSectionComponent } from './reactive-context/se-validation/se-validation-section/se-validation-section.component';
export {
    SeValidationSectionComponent,
} from './reactive-context/se-validation/se-validation-section/se-validation-section.component';
import { SeValidationRuleDirective } from './reactive-context/se-validation/se-validation-rule.directive';
export { SeValidationRuleDirective } from './reactive-context/se-validation/se-validation-rule.directive';
export { ValidationRule, ValidationChanges } from './reactive-context/se-validation/models';

export { IReactiveValidator } from './reactive-context/reactive-context';
export { SeReactiveValidator } from './reactive-context/reactive-viewmodel/se-reactive-validators';
export {
    IdDescriptionPair,
    SeReactiveProperty,
    SeReactiveViewModel,
} from './reactive-context/reactive-viewmodel/se-reactive-viewmodel';

export { Store } from './redux/store';
export { IReducer, IAction, ListenerCallback, UnsubscribeCallback } from './redux/reducer';
export { IMiddleware, DevToolsMiddleware, LogMiddleware } from './redux/middlewares';

export { IEstensaButtonData, IEstensaButtonStatus } from './interfaces/IEstensaButtonData';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        SeUiControlsModule,
        SeUiUtilitiesModule,
        MatBadgeModule,
        MatButtonModule,
        MatButtonToggleModule,
        MatCardModule,
        MatCheckboxModule,
        MatDatepickerModule,
        MatDialogModule,
        MatExpansionModule,
        MatGridListModule,
        MatIconModule,
        MatInputModule,
        MatListModule,
        MatMenuModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatRadioModule,
        MatSelectModule,
        MatSidenavModule,
        MatSliderModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatStepperModule,
        MatTableModule,
        MatTabsModule,
        MatToolbarModule,
        MatTooltipModule,
        MatTreeModule,
    ],
    declarations: [
        SeToolbarComponent,
        SeIteratorActionsComponent,
        SeValidationSectionComponent,
        SeValidationRuleDirective,
    ],
    exports: [
        SeUiControlsModule,
        SeUiUtilitiesModule,
        SeToolbarComponent,
        SeIteratorActionsComponent,
        SeValidationSectionComponent,
        SeValidationRuleDirective,
    ],
})
export class SeUiAdvancedModule {}
